<template>
  <v-row>
    <v-card flat tile width="100%">
      <template v-if="rate.price.price > 0.0">
        <v-row no-gutters>
          <v-col class="d-flex justify-start">
            <v-chip
              x-small
              label
              color="teal darken-3"
              dark
              class="px-1 font-weight-bold chip-x-small-custom"
              >{{ rate.currency }}</v-chip
            >
          </v-col>
          <v-col class="d-flex justify-end">
            <v-chip
              x-small
              label
              color="blue-grey"
              dark
              class="px-1 font-weight-bold chip-x-small-custom"
              >{{ rate.uom }}</v-chip
            >
          </v-col>
        </v-row>

        <v-row justify="center" class="py-2">
          <span class="overline font-weight-bold">{{ rate.price.price.toFixed(2) }}</span>
          <span class="overline font-weight-bold mx-1">/</span>
          <span class="overline font-weight-bold error--text">{{
            rate.cost.cost.toFixed(2)
          }}</span>
        </v-row>

        <v-row v-if="rate.price.min_price > 0.0" justify="end">
          <v-chip
            x-small
            label
            color="accent"
            dark
            class="px-1 font-weight-bold chip-x-small-custom"
            >min</v-chip
          >
        </v-row>
      </template>

      <template v-else>
        <v-row justify="center" align="center" class="fill-height">
          <span class="overline grey--text font-weight-bold">N/A</span>
        </v-row>
      </template>
    </v-card>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: ["rates"],

  data() {
    return {
      rate: this.rates,
    };
  },
  created() {},
  mounted() {},
  watch: {
    rates() {
      this.rate = this.rates;
    },
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.v-chip.v-size--x-small.chip-x-small-custom {
  font-size: 9px;
  height: 12px;
}
</style>
